module.exports = __webpack_public_path__ + "media/images/icons/twotone/hourglass-e7ce9d9f58f63322921a3faab8b11b6b.svg";